import './VoiIcon.scss';

function VoiIcon(props): JSX.Element {
  return (
      <span className="voi-icon no-select">&nbsp;V</span>
  );
}

export default VoiIcon;
